import { render, staticRenderFns } from "./PDFViewerV2.vue?vue&type=template&id=1ecb8a39&scoped=true&"
import script from "./PDFViewerV2.vue?vue&type=script&lang=js&"
export * from "./PDFViewerV2.vue?vue&type=script&lang=js&"
import style0 from "./PDFViewerV2.vue?vue&type=style&index=0&id=1ecb8a39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb8a39",
  null
  
)

export default component.exports